import request from '../request';
// 查询赛事
const queryGameList = (data) => {
    return request.get(`/midesk/wordCup/queryGameList/${data.openId}`, data)
}
// 更新或保存
const saveOrUpdate = (data) => {
    return request.post('/midesk/wordCup/saveOrUpdate', data)
}
// 查询我的竞猜结果
const quizList = (data) => {
    return request.get(`/midesk/wordCup/quizList/${data.openId}/${data.type}`, data)
}
// 查询最新用户信息
const queryRecordByOpenId = (data) => {
    return request.post(`/midesk/wordCup/queryRecordByOpenId/${data.openId}`, data)
}

export default {
    queryGameList,
    saveOrUpdate,
    quizList,
    queryRecordByOpenId
};